var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v(_vm._s(_vm.row.institutionName))]),_c('div',[_vm._v("ID: "+_vm._s(_vm.row.institutionId))])])
}
var staticRenderFns = []

export { render, staticRenderFns }